import React, { Component } from "react";
import {
  InputGroup,
  Row,
  Col,
  Button,
  Table,
  Modal, ModalHeader, ModalBody, ModalFooter
} from "reactstrap";

import Collapsible from 'react-collapsible';
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux';
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import Pagination from "react-js-pagination";
import * as congNoAction from './actions'
import * as congNoConstant from './constants'
import DisplayRecordText from "../controls/_DisplayRecordText"
import { currentDate, getParam, abs2number } from "../../lib/common";
import Select from 'react-select';
import ViewThanhToan from './_ViewThanhToan';
import { BtnPermissions, BtnType } from '../../lib/BtnPermissions';
import { ButtonExt } from "../controls/ButtonExt"
import CheckboxTreeList from "../controls/_CheckboxTreeList";
import ExcelReader from "../controls/_ExcelReader";
import Messages from '../../notifications/Messages'
import Errors from '../../notifications/Errors'
const fileTemplate = '/templates/dsCongNoDauKy.xls';
const isNumber = require('is-number');
class CongNoKhachHang extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tuNgay: currentDate().startOf('month'),
      denNgay: currentDate().endOf("days"),
      list: [],
      total_record: 0,
      page: 1,
      per_page: 20,
      total: {},
      keyword: "",
      listKH: [],
      selectedOptionKhachHang: null,
      nvId: 0,
      listNvkd: [],
      TinhThanhId: "",
      selectedOptionNhanVien: [],
      khId: 0,
      modalUpdateThanhToan: false,
      objThanhToan: {},
    };
    this.handleDateChange = this.handleDateChange.bind(this);
  }
  viewThanhToan = (obj) => {
    obj["SoTienThanhToan"] = (obj.NoCuoiKy || 0 - obj.CoCuoiKy || 0)
    obj["NgayThanhToan"] = currentDate()
    this.setState({ modalUpdateThanhToan: true, objThanhToan: obj })
  };
  handleCloseThanhToan = () => {
    this.setState({ modalUpdateThanhToan: false })
  };
  handleDateChange = (e, name) => {
    switch (name) {
      case "tuNgay":
        this.setState({ tuNgay: e });
        break;
      case "denNgay":
        this.setState({ denNgay: e });
        break;
    }
  }
  viewKh = (e, item) => {
    e.preventDefault()
    const {
      nvId,
      khId,
      tuNgay,
      denNgay
    } = this.state

    const prevUri = encodeURIComponent("/#/congnokh?nv=" + nvId + "&kh=" + khId + "&t=" + tuNgay.unix() + "&d=" + denNgay.endOf('days').unix())
    const nextUri = `${"/congnokhct?kh=" + item.KhachHangId + "&nv=" + item.NhanVienId + "&t=" + this.state.tuNgay.unix() + "&d=" + this.state.denNgay.endOf('days').unix() + "&prev=" + prevUri}`
    this.props.history.push(nextUri)
  };

  handleChangeKh = selectedOptionKhachHang => {
    let option = selectedOptionKhachHang || { value: 0 }
    this.setState({ selectedOptionKhachHang: option, khId: option.value });
  };
  handlePageChange = (pageNumber) => {
    let page = parseInt(pageNumber || 1)
    return this.setState({ page }, this.fetchList);
  }
  fetchList(page) {
    var requestData = {
      nvId: this.state.nvId,
      khId: this.state.khId,
      fromDate: this.state.tuNgay.unix(),
      toDate: this.state.denNgay.endOf('days').unix(),
      page: page || this.state.page,
      per_page: this.state.per_page,
    }
    const onSuccess = ({ records, total_record }) => {
      const sumTotal = total_record ? total_record[0] : {}
      this.setState(
        {
          total_record: sumTotal.countRecord,
          list: records,
          total: sumTotal,
        }
      )
    }
    this.props.congNoListRequest(requestData, onSuccess)
  }
  toggle = () => {
    this.setState(prevState => ({
      modal: !prevState.modal,
      dataErr: [],
      messages: ''
    }));
  }
  exportXls = () => {
    var requestData = {
      nv: this.state.nvId,
      kh: this.state.khId,
      t: this.state.tuNgay.unix(),
      d: this.state.denNgay.endOf('days').unix()
    };
    this.props.reportExportXlsRequest(requestData, (item) => {
      var dataFile = new Blob([item], {
        type: "application/vnd.ms-excel;charset=UTF-8"
      });
      var fileURL = URL.createObjectURL(dataFile);
      var id = 'dlinkExportCongNo';
      var fileName = "CongNoTheoKhachHang.xls";
      var link = document.getElementById(id);
      if (link == null) {
        var a = document.createElement('a');
        a.style = "display:none;";
        a.id = "dlinkExportCongNo";
        document.body.appendChild(a);
        link = a;
      }
      var filename = prompt("File name", fileName);
      if (filename) {
        link.href = fileURL;
        link.download = filename;
        link.click();
        link.remove();
      }
    });
  }
  search = () => {
    if (this.props.congNoKh.listRequesting) {
      return false;
    }
    return this.setState({ page: 1 }, () => {
      this.fetchList(1);
    });
  }
  onChangeItem = (itemPerPage) => {
    this.setState({ per_page: itemPerPage }, () => {
      this.search();
    });
  }
  fetchNvkd = () => {
    const { congNoNvkdListRequest } = this.props
    const { nvId } = this.state
    var requestData = {};
    return congNoNvkdListRequest(requestData, (data) => {
      this.setState({
        listNvkd: data,
      });
      if (nvId != 0) {
        // load khach hang
        this.fetchKH([nvId])
      }
    });
  }
  fetchKH = (nvIds) => {
    const { congNoDsKhListRequest } = this.props
    var requestData = {
      nvkds: nvIds
    };
    return congNoDsKhListRequest(requestData, (data) => {
      this.setState({
        listKH: data.map((item) => { return { value: item.Id, label: item.Name } })
      });
    });
  }
  ThanhToanCongNo = (obj) => {
    var requestData = {
      NhanVienId: obj.NhanVienId,
      KhachHangId: obj.KhachHangId,
      SoTienThanhToan: obj.SoTienThanhToan,
      congNoKhId: null,
      GhiChu: obj.GhiChu,
      NgayThanhToan: obj.NgayThanhToan.unix()
    };
    this.props.congNoNvUpdateRequest(requestData, () => {
      this.handleCloseThanhToan();
      this.search();
    })
  }
  onHandleRemoveNvkd = () => {
    this.setState({ nvId: 0, khId: 0, selectedOptionKhachHang: [] }, () => {
      this.fetchKH([this.state.nvId]);
    })
  }
  onHandleChoiceNvkd = (nodesChecked) => {
    this.setState({ nvId: nodesChecked.length > 0 ? nodesChecked[0].value : 0 }, () => {
      this.fetchKH([this.state.nvId]);
    })
  }
  BuildSelectOption(list, type) {
    const { nvId, khId } = this.state
    var options = [];
    if (list && list.length > 0) {
      if (type == "TINHTHANH") {
        options.push({ value: 0, label: '--Tất cả tỉnh thành--', ma: 0 })
        list.map((item) => { options.push({ value: item.TinhThanhId, label: item.Ten, ma: item.Ma }) });
      }
      if (type == "NVKD") {
        list.map((item) => {
          let option = { value: item.NhanVienId, label: item.TenNhanVien }
          options.push(option)
          if (option.value == nvId) {
            // set selection to skip old value
            this.setState({
              selectedOptionNhanVien: option
            })
          }
        });
      }
      if (type == "KH") {
        list.map((item) => {
          let option = { value: item.Id, label: item.Name }
          options.push(option)
          if (option.value == khId) {
            // set selection to skip old value
            this.setState({
              selectedOptionKhachHang: option
            })
          }
        });
      }
    }
    return options;
  }
  DownLoadFile = () => {
    const link = document.createElement('a');
    link.href = fileTemplate;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  UploadExcel = (data) => {
    let arrData = [];
    if (data.length > 0) {
      var i;
      for (i = 1; i < data.length; i++) {
        let ngayChot = '';
        if (data[i][6] != '') {
          let tmpNgay = data[i][6].split('/');
          if (tmpNgay.length == 3) {
            ngayChot = tmpNgay[2] + '-' + tmpNgay[1] + '-' + tmpNgay[0];
          }
        }
        arrData.push({
          maNV: data[i][0],
          tenNV: data[i][1],
          maKH: data[i][2],
          tenKH: data[i][3],
          noDK: data[i][4],
          coDK: data[i][5],
          NgayChot: ngayChot,
          ghiChu: data[i][7],
         
        })
      }
      const { congNoNvUploadRequest } = this.props
      var requestData = {
        items: arrData
      };
      const onSuccess = ({ data}) => {
        if (data && data.length > 0) {
          this.setState({ dataErr : data });
        } else {
          setTimeout(() => {
           this.toggle();
           this.fetchList(1);
          }, 1000)
        }
      }
      return congNoNvUploadRequest(requestData,onSuccess);
    }
  }
  checkParams = (callback) => {
    const { location } = this.props
    let nv = getParam(location, "nv", 0);
    let kh = getParam(location, "kh", 0);
    let t = getParam(location, "t", this.state.tuNgay.unix());
    let d = getParam(location, "d", this.state.denNgay.unix());
    this.setState({
      khId: kh,
      tuNgay: moment.unix(t),
      denNgay: moment.unix(d),
      nvId: nv,
      selectedOptionNhanVien: isNumber(nv) ? [parseInt(nv)] : null
    }, callback)
  }
  componentDidMount() {
    this.checkParams(() => {
      this.fetchNvkd()
      this.fetchList(1)
    })
  }

  render() {
    const {
      list,
      selectedOptionNhanVien,
      selectedOptionKhachHang,
      listNvkd,
      listKH,
      dataErr
    } = this.state

    const {
      handleSubmit,
      congNoKh: {
        listRequesting,
        isRequesting,
        errors,
        isPopupLoading,
        messages
      },
    } = this.props
    const getUriPayHistory = (item) => {
      return `/#/lichsu-thanhtoan?loai=${congNoConstant.LOAI_CONG_NO.KHACH_HANG}&objectId=${item.KhachHangId}`
    }
    const startIndex = (this.state.page > 0 ? this.state.page - 1 : 0) * this.state.per_page
    return (
      <div className="animated fadeIn">
        <BlockUi tag="div" blocking={listRequesting} >
          <div>
            <Collapsible trigger="Tìm kiếm..." overflowWhenOpen="inherit" open={true}>
              <Row className="report-control">
                <Col sm="2" xs="6" className="mb-2 pr-0 half-left">
                  <InputGroup size="md">
                    <span className="add_date_exs_span">Từ:</span>
                    <DatePicker
                      name="denNgay"
                      placeholder="đến ngày"
                      selected={this.state.tuNgay}
                      onChange={e => this.handleDateChange(e, "tuNgay")}
                      required className={"form-control add_date_exs_input"}
                      dateFormat="DD/MM/YYYY" />
                  </InputGroup>
                </Col>
                <Col sm="2" xs="6" className="mb-2 pr-0 half-right">
                  <InputGroup size="md">
                    <span className="add_date_exs_span">Đến:</span>
                    <DatePicker
                      name="denNgay"
                      placeholder="đến ngày"
                      selected={this.state.denNgay}
                      onChange={e => this.handleDateChange(e, "denNgay")}
                      required className={"form-control add_date_exs_input"}
                      dateFormat="DD/MM/YYYY" />
                  </InputGroup>
                </Col>
                <Col sm="4" className="mb-2">
                  <InputGroup size="md">
                    <CheckboxTreeList
                      placeholder={`--Nhân viên KD--`}
                      nodes={listNvkd}
                      isMultiChoice={false}
                      checked={selectedOptionNhanVien}
                      onHandleRemove={(item) => this.onHandleRemoveNvkd(item)}
                      onChoice={e => this.onHandleChoiceNvkd(e)}
                    />
                  </InputGroup>
                </Col>
                <Col sm="4" className="mb-2">
                  <InputGroup size="md">
                    <Select
                      name="KhachHang"
                      className="w-100"
                      placeholder="Chọn khách hàng"
                      value={selectedOptionKhachHang}
                      onChange={this.handleChangeKh}
                      options={listKH}
                      isClearable
                      isSearchable
                      closeMenuOnSelect={true}
                    />
                  </InputGroup>
                </Col>
              </Row>
            </Collapsible>
            <div className="w-100 mb-2 mt-2">
              <Button size="md" color="success" className="mr-1" onClick={handleSubmit(this.search)}><i className="fa fa-search"></i> Thống kê</Button>&nbsp;
              <Button size="md" color="primary" className="mr-1" onClick={this.exportXls.bind(this, {})}><i className="fa fa-file-excel-o"></i> Xuất excel</Button>
              <ButtonExt btnClass="mr-1"
                    color="primary"
                    iconClass="fa-upload"
                    displayText="Nhập đầu kỳ"
                    btnClick={() => this.toggle()}
                    permission={BtnPermissions.CongNoKhachHang.NHAPDAUKY} />
            </div>
          </div>
          <div className="mt-2 bg-white">
            <div className="w-100">
              <DisplayRecordText
                itemsCountPerPage={this.state.per_page}
                onChangeItem={this.onChangeItem}
              />
              <Table hover responsive className="mb-0 d-sm-table table-sm table-bordered">
                <thead className="thead-default">
                  <tr>
                    <th scope="col" rowSpan="2" width="50" className="text-center">#</th>
                    <th scope="col" rowSpan="2" className="text-center">Mã khách hàng</th>
                    <th scope="col" rowSpan="2" className="text-center">Tên khách hàng</th>
                    <th scope="col" rowSpan="2" className="text-center">Địa chỉ</th>
                    <th scope="col" colSpan="2" className="text-center">Đầu kỳ</th>
                    <th scope="col" colSpan="2" className="text-center">Phát sinh</th>
                    <th scope="col" colSpan="2" className="text-center">Cuối kỳ</th>
                    <th scope="col" rowSpan="2" width="80" className="text-center">Thanh Toán</th>
                    <th scope="col" rowSpan="2" width="80" className="text-center">Lịch sử</th>
                  </tr>
                  <tr>
                    <th className="text-center">Nợ</th>
                    <th className="text-center">Có</th>
                    <th className="text-center">Nợ</th>
                    <th className="text-center">Có</th>
                    <th className="text-center">Nợ</th>
                    <th className="text-center">Có</th>
                  </tr>
                </thead>
                <tbody>
                  {list && !!list.length && (
                    list.map((res, idx) => (
                      <tr key={idx + 1}>
                        <td className="text-center">{startIndex + (idx + 1)}</td>
                        <td className="text-center">{res.MaKhachHang}</td>
                        <td className="text-left"><a href='#' onClick={(e) => this.viewKh(e, res)}>{res.TenKhachHang}</a></td>
                        <td className="text-left">{res.DiaChiKh}</td>
                        <td className="text-right">{parseFloat(abs2number(res.NoDauKy || 0, res.CoDauKy || 0)).toLocaleString("vi-VN", { minimumFractionDigits: 0 })} </td>
                        <td className="text-right">{parseFloat(abs2number(res.CoDauKy || 0, res.NoDauKy || 0)).toLocaleString("vi-VN", { minimumFractionDigits: 0 })} </td>
                        <td className="text-right">{parseFloat(res.NoPhatSinh || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })} </td>
                        <td className="text-right">{parseFloat(res.CoPhatSinh || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })} </td>
                        <td className="text-right">{parseFloat(abs2number(res.NoCuoiKy || 0, res.CoCuoiKy || 0)).toLocaleString("vi-VN", { minimumFractionDigits: 0 })} </td>
                        <td className="text-right">{parseFloat(abs2number(res.CoCuoiKy || 0, res.NoCuoiKy || 0)).toLocaleString("vi-VN", { minimumFractionDigits: 0 })} </td>
                        <td className="text-center">
                          {
                            (res.NoCuoiKy || 0) - (res.CoCuoiKy || 0) > 0 ?
                              <ButtonExt btnClass="mr-1 text-primary"
                                iconClass="fa-money"
                                displayText="TT"
                                btnType={BtnType.ButtonLink}
                                btnClick={() => this.viewThanhToan(res)}
                                permission={BtnPermissions.CongNoKhachHang.THANHTOAN} />
                              : ""
                          }

                          {/* <a href='#' className=" text-primary font-weigh-bold" onClick={(e) => this.viewThanhToan(e, res)}><i className="fa fa-money mr-1"></i>TT</a> : "" */}
                        </td>
                        <td className="text-center">
                          <a href={getUriPayHistory(res)} target="_blank" className="text-success font-weigh-bold"><i className="fa fa-eye mr-1"></i>Xem</a>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
                <tfoot>
                  <tr>
                    <th scope="col" colSpan="4" className="text-right">
                      Tổng cộng
                    </th>
                    <th scope="col" className="text-right">
                      <span className="text-success">
                        {(abs2number(this.state.total.t_NoDauKy || 0, this.state.total.t_CoDauKy || 0)).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}
                      </span>
                    </th>
                    <th scope="col" className="text-right">
                      <span className="text-success">
                        {(abs2number(this.state.total.t_CoDauKy || 0, this.state.total.t_NoDauKy || 0)).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}
                      </span>
                    </th>
                    <th scope="col" className="text-right">
                      <span className="text-success">
                        {(this.state.total.t_NoPhatSinh || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}
                      </span>
                    </th>
                    <th scope="col" className="text-right">
                      <span className="text-success">
                        {(this.state.total.t_CoPhatSinh || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}
                      </span>
                    </th>
                    <th scope="col" className="text-right">
                      <span className="text-success">
                        {(abs2number(this.state.total.t_NoCuoiKy || 0, this.state.total.t_CoCuoiKy || 0)).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}
                      </span>
                    </th>
                    <th scope="col" className="text-right">
                      <span className="text-success">
                        {(abs2number(this.state.total.t_CoCuoiKy || 0, this.state.total.t_NoCuoiKy || 0)).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}
                      </span>
                    </th>
                    <th scope="col" colSpan="2"></th>
                  </tr>
                </tfoot>
              </Table>
              {this.state.total_record > this.state.per_page && (
                <Pagination
                  activePage={this.state.page}
                  itemsCountPerPage={this.state.per_page}
                  totalItemsCount={this.state.total_record}
                  pageRangeDisplayed={5}
                  onChange={this.handlePageChange}
                />
              )}
            </div>
            <div className="clearfix"></div>
          </div>
          <ViewThanhToan item={this.state.objThanhToan}
            isRequesting={isRequesting}
            isOpen={this.state.modalUpdateThanhToan}
            onClose={this.handleCloseThanhToan}
            ThanhToanCongNo={this.ThanhToanCongNo}
            errors={errors}
            messages={messages}
          />
                    <div>
            <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
              <BlockUi tag="div" blocking={isPopupLoading}>
                <ModalHeader toggle={this.toggle}>Cập nhật tồn đầu kỳ</ModalHeader>
                <ModalBody>
                  <ExcelReader UploadExcel={this.UploadExcel} />
                  <div style={{ maxHeight: 300, overflowX: "auto" }}>
                    {dataErr && !!dataErr.length && (
                      dataErr.map((res, idx) => (
                        <p key={idx} className="text-danger mb-0"><i className="fa fa-exclamation-circle"></i> {res}</p>
                      ))
                    )}
                  </div>
                  {!isPopupLoading && !!errors.length && (
                    <Errors errors={errors} />
                  )}
                  {dataErr && dataErr.length == 0 && !isPopupLoading && !!messages.length && (
                    <Messages messages={messages} />
                  )}
                </ModalBody>
                <ModalFooter style={{ padding: "5px" }}>
                  <Button size="md" color="success" onClick={this.DownLoadFile}><i className="fa fa-download"></i> Tải file mẫu</Button>{' '}
                  <Button size="md" color="secondary" onClick={this.toggle}><i className="fa fa-close"></i> Đóng</Button>
                </ModalFooter>
              </BlockUi>
            </Modal>
          </div>
        </BlockUi>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  congNoKh: state.congNoKh,
  client: state.client,
})

const connected = connect(mapStateToProps, {
  congNoNvkdListRequest: congNoAction.congNoNvkdListRequest,
  congNoDsKhListRequest: congNoAction.congNoDsKhListRequest,
  congNoListRequest: congNoAction.congNoListRequest,
  reportExportXlsRequest: congNoAction.reportExportXlsRequest,
  congNoNvUpdateRequest: congNoAction.congNoNvUpdateRequest,
  congNoDvhcListRequest: congNoAction.congNoDvhcListRequest,
  congNoNvUploadRequest: congNoAction.congNoNvUploadRequest
})(CongNoKhachHang)

const formed = reduxForm({
  form: 'congNoKh',
})(connected)

export default formed;




// WEBPACK FOOTER //
// ./src/views/CongNoKhachHang/CongNoKhachHang.js